export const translations = {
  da: {
    nav: {
      forloeb: "Uddannelse",
      workshops: "Kursus",
      foredrag: "Foredrag",
      privat: "Til Private",
      virksomheder: "Virksomheder",
      frisaetDig: "Frisæt dig",
      kvindePower: "KVINDE - Kend din power!",
      sessioner: "Sessioner",
      retreats: "Retreats",
      sjaelensIntelligens: "Hjertets Intelligens",
      montserrat: "Montserrat",
      taenketank: "Tænketank",
      omMette: "Om Mette",
      blog: "Blog",
      podcasts: "Podcast",
      gratis: "Gratis og events",
      kontakt: "Kontakt",
      bookSession: "Book Session",
      bookMeeting: "Book et møde/afklaring",
      quickLinks: "Hurtige Links",
      legal: "Juridisk",
      privacyPolicy: "Privatlivspolitik"
    },
    common: {
      readMore: "Læs mere",
      seeMore: "Se mere",
      backToHome: "Tilbage til forsiden",
      backToBlog: "Tilbage til alle indlæg",
      back: "Tilbage",
      submit: "Send besked",
      submitting: "Sender...",
      successTitle: "Tak for din henvendelse!",
      successMessage: "Jeg vender tilbage til dig hurtigst muligt.",
      errorTitle: "Der opstod en fejl",
      errorMessage: "Prøv venligst igen senere eller kontakt mig direkte pr. e-mail.",
      contactHeader: "Lad os starte en samtale",
      contactSub: "Udfyld formularen herunder, eller skriv direkte til mig.",
      name: "Fulde navn",
      email: "E-mailadresse",
      phone: "Telefonnummer",
      subject: "Emne / Hvad drejer det sig om?",
      message: "Din besked",
      category: "Kategori",
      date: "Dato",
      duration: "Varighed",
      listenPodcast: "Lyt til podcasten på Spotify",
      readArticle: "Læs hele artiklen",
      listenEpisode: "Lyt til podcastepisoden",
      share: "Del denne artikel",
      price: "Pris",
      practical: "Praktisk information",
      location: "Placering",
      included: "Hvad er inkluderet?",
      bookNow: "Tilmeld / Book her"
    },
    home: {
      badge: "Hjertets Tidsalder & Ny Tids Lederskab",
      heroTitle: "Ny tids personligt lederskab",
      heroSub: "Skab et liv med mod, tillid og sjælsforbindelse",
      ctaPrimary: "Udforsk Frisæt Dig Forløbet",
      ctaSecondary: "Om Mette",
      introHeading: "Er du klar til at træde ind i dit fulde potentiale?",
      introWelcome: "Så hjertelig velkommen til min side.",
      introP1: "Jeg hjælper dig med at vågne op til dig selv, forbinde dig med din intuition og sjælskerne og leve et autentisk liv, du elsker.",
      introP2: "Verden har brug for mennesker, der mærker sig selv og er i stand til at lede sig selv og andre fra sin rene essens og ikke fra en serie triggers af gamle frygtbaserede mønstre og traumer.",
      introP3: "Vil du også gerne være med til at skabe en bedre verden? Så start med dig selv, og træd med ind i en ny tid og en ny version af dig, hvor sjælsforbindelse og livsglæde er vejen til indre og ydre fred.",
      introP4: "Her på siden kan du læse om personlig spirituel udvikling, ny tids lederskab og den nye tid, vi evolutionært er på vej ind i.",
      introCta: "Se workshops & foredrag",
      videoTitle: "Velkommen til min hjemmeside",
      whoBadge: "Baggrund & Vision",
      whoHeading: "Hvem er jeg?",
      whoP1: "Jeg har selv levet på den gamle spillebane, hvor hamsterhjulet, karriereræset og frygten for at være anderledes var ved at æde mig op.",
      whoP2: "Indtil jeg vågnede op til min sande essens og så, hvor anderledes og vidunderligt livet er, når man tør følge sin livsbane og sine medfødte talenter og gaver. Og hvor stor støtte, livet giver os, når vi finder tillid og mod til at gå i flow med det.",
      whoP3: "Jeg har baggrund som Kommerciel Direktør, futurist, coach, journalist, efterskolelærer, forretningsudvikler, professionelt bestyrelsesmedlem, clairvoyant rådgiver og spirituel lærer.",
      whoP4: "Det er dog ikke så vigtigt. Det vigtige er, at jeg forstår, hvordan ledelse, karriere, spirituel opvågning og at leve fra sin sjælskerne skaber fred i det enkelte menneske og dermed fred i verden.",
      whoP5: "Og det er det, der er min passion og mit livsformål. At bidrage til at skabe fred, bæredygtighed og ægte velstand i verden ét menneske ad gangen.",
      whoCta: "Kontakt mig for en uforpligtende samtale",
      testimonialsHeading: "Er du klar til at åbne for sjælens kraft og intelligens i dig?",
      testimonialsSub: "Udtalelser fra andre, der har valgt at tage skridtet indad sammen med mig:",
      testimonialsCta: "Læs mere om Mette her",
      podcastHeading: "Lyt med i universet",
      podcastBadge: "Lyt med",
      podcastFeatured: "Primær",
      podcastCta: "Udforsk alle episoder & artikler",
      bottomCtaHeading: "Vil du starte din rejse i dag?",
      bottomCtaSub: "Uanset om det er gennem et foredrag, et intimt retreat eller en 1:1 session, er du så velkommen.",
      bottomCtaBtn: "Book en samtale / Kontakt"
    },
    foredragPage: {
      badge: "Inspirerende Oplæg & Kurser",
      title: "Foredrag & Workshops",
      sub: "Inspirerende, øjenåbnende og dybt forandrende indlæg til både erhvervslivet og private.",
      privateTabTitle: "Til Private",
      privateTabDesc: "Styrk dit indre kompas og frisæt din egen power.",
      businessTabTitle: "Til Virksomheder",
      businessTabDesc: "Skab trivsel, bevidsthed og bæredygtigt Ny Tids Lederskab.",
      bookingTitle: "Book et foredrag eller en workshop",
      bookingSub: "Udfyld formularen for at forespørge på datoer, priser og skræddersyede forløb."
    },
    frisaetDigPage: {
      badge: "Frisæt dig",
      title: "Frisæt Dig",
      sub: "Ønsker du at mærke, hvem du inderst inde er, og hvad et drømmeliv er for dig? At sætte dig selv fri af gamle mønstre og overbevisninger, så du kærligt og værdigt altid har din egen ryg og kan sige roligt fra uden fortrydelse? Så er dette forløbet til dig.",
      section1Title: "Om Frisæt Dig",
      section1Text: "Mange af os er opdraget i et samfund, hvor succes måles på ydre resultater, kontrol og kontinuerlig præstation. Men når frygt og overudviklet kontrol styrer rattet, mister vi kontakten til vores intuition og livsglæde.",
      section1SubText: "Frisæt dig er en invitation til at lægge den opslidende rustning fra dig og genopdage den ro og sikkerhed, der bor dybt i din egen sjælskerne.",
      pathwaysTitle: "3 Veje til Frisættelse",
      foredragTitle: "1. Foredrag",
      foredragDesc: "Et stærkt, nærværende og øjenåbnende foredrag, der sætter ord på det kollektive præstationsmønster og viser vejen ud.",
      workshopTitle: "2. Workshop",
      workshopDesc: "En fordybende workshop med refleksion, energiøvelser og konkrete værktøjer til at give slip på kontrol og frygt.",
      forloebTitle: "3. Forløb",
      forloebDesc: "Et dybtgående transformerende årsforløb (fysisk eller online), hvor vi arbejder systematisk med din personlige og spirituelle udvikling."
    },
    kvindePowerPage: {
      badge: "Transformation",
      title: "KVINDE - Kend din power!",
      sub: "Verden har ikke brug for hårde kvinder med spidse albuer. Den har brug for kvinder, der kender sin egen kraft og tør stå i den – med sensitivitet, intuition, hjerte og mod",
      mainHeading: "Et opgør med det traditionelle syn på en powerkvinde",
      p1: "Verden har ikke brug for kvinder, der opfører sig som mænd. Verden har brug for kvinder, der kender deres kraft og kvaliteter og er i stand til at stå i deres fulde styrke med al den livgivende og fredsskabende blødhed, fintunede intuition og moderlige overblik, som ligger i den modne feminine kraft.",
      p2: "Mine forløb, workshops og foredrag 'Kvinde – kend din power' handler om at træde ud af præstationsmønsteret og lede med hjertet.",
      pathwaysTitle: "Deltag som workshop, foredrag eller forløb"
    },
    sessionerPage: {
      badge: "Personlig Fordybelse",
      title: "1:1 Sessioner",
      sub: "Skab klarhed, retning og dyb forbindelse til din intuition gennem clairvoyant rådgivning, ledersparring og spirituelle mentorforløb.",
      tab1: "Clairvoyant Rådgivning og Personlig Sparring",
      tab2: "Fortrolig Intuitiv Ledersparring",
      tab3: "Spirituelt Mentorforløb",
      clairvoyanceTitle: "Clairvoyant Rådgivning og Personlig Sparring",
      clairvoyanceSub: "Har du brug for klarhed og indsigt? Måske fordi du står ved en skillevej, har svært ved at mærke dig selv og se klart eller har brug for at forstå, hvad der kalder på dig.",
      ledersparringTitle: "Fortrolig Intuitiv Ledersparring",
      ledersparringSub: "Et fortroligt og bevidst rum til dig som leder, direktør eller iværksætter, der ønsker at lede med integritet, vision og hjerte.",
      mentorTitle: "Spirituelt Mentorforløb",
      mentorSub: "Et dedikeret og intensivt forløb over flere måneder for dig, der ønsker dyb forvandling og vedvarende støtte på din vej."
    },
    retreatsPage: {
      badge: "Spirituel Fordybelse",
      title: "Retreats",
      sub: "Skab rum til fordybelse, restitution og åndelig fornyelse i magiske omgivelser.",
      sjaelTitle: "Hjertets Intelligens Retreat",
      sjaelDesc: "Genopfind din indre ro og tilslut dig det universelle felt af bevidsthed.",
      montserratTitle: "Helligt Retreat til Montserrat",
      montserratDesc: "En 5-dages pilgrimsrejse til klostret i det spanske bjerglandskab Montserrat."
    },
    montserratPage: {
      badge: "Eksklusiv Pilgrimsrejse",
      title: "Helligt Retreat til Montserrat",
      sub: "5 dages fordybelse, åndelig fornyelse og indre ro i Cataloniens spektakulære bjerge.",
      programTitle: "Program & Oplevelser",
      priceTitle: "Pris & Betingelser",
      bookingTitle: "Ansøg om en plads på Montserrat Retreat"
    },
    taenketankPage: {
      badge: "New Earth Leaders Academy",
      title: "NELA Tænketank & Uddannelser",
      sub: "Gentænk lederskab. Vi skaber nye rammer, nye regler og nye bevidsthedsformer.",
      philosophyTitle: "Filosofien: Gamle rammer – gamle regler",
      philosophyText: "De traditionelle hierarkiske og præstationsfokuserede organisationer udbrænder både ledere og medarbejdere. NELA er fællesskabet for fremtidens banebrydende ledere."
    },
    omMettePage: {
      badge: "Velkommen",
      title: "Velkommen til Mette Brudvig",
      sub: "Jeg hjælper dig hjem til dig selv, dit hjerte og dit personlige lederskab.",
      intro: "Jeg havde selv svært ved at finde det rette sted at gå hen, da min sjæl og mit hjerte bankede på og ville have plads. Derfor er jeg glad for at kunne være det sted for dig. Enten via inspiration her på siden eller fordi du ønsker at tage din udvikling med mig."
    },
    udtalelserPage: {
      badge: "Klientudtalelser",
      title: "Udtalelser",
      intro: "Her kan du se et udpluk af udtalelser fra klienter, der har været i sessioner eller er i forløb med mig."
    },
    blogPage: {
      badge: "Inspiration & Fordybelse",
      title: "Blog",
      sub: "Inspiration, dybe indsigter og personlige artikler om den nye tid, hjertets intelligens og den spirituelle transformation.",
      featuredBadge: "Fremhævet Blogindlæg",
      moreArticles: "Flere Blogindlæg",
      readFull: "Læs hele indlægget",
      readMore: "Læs mere"
    },
    podcastsPage: {
      badge: "Lyt med i universet",
      title: "Podcast",
      sub: "Samtaler og dybe refleksioner om den nye tid, hjertets intelligens, kvantefysik og personligt lederskab.",
      listenBelow: "Lyt direkte herunder",
      featuredBadge: "Fremhævet Podcast",
      listenSpotify: "Lyt på Spotify",
      listenBuzzsprout: "Buzzsprout (Web & episoder)",
      episodesTitle: "Episoder fra Buzzsprout",
      episodesSub: "Udforsk alle afsnit fra podcasten 'Forbundet i den nye tid'. Lyt til samtaler om spiritualitet, kvantefysik, astrologi og hjertets intelligens.",
      searchPlaceholder: "Søg i episoder (titel, gæst, emne...)",
      allEpisodes: "Alle episoder",
      listenOnBuzzsprout: "Lyt på Buzzsprout",
      streamDirectly: "Hør seneste afsnit direkte",
      duration: "Varighed",
      playEpisode: "Afspil på siden",
      pauseEpisode: "Pause",
      nowPlaying: "Afspiller nu",
      rewind15: "Spol 15 sek. tilbage",
      forward15: "Spol 15 sek. frem",
      closePlayer: "Luk afspiller",
      noEpisodesFound: "Ingen episoder matcher din søgning."
    },
    kontaktPage: {
      badge: "Start Samtalen",
      title: "Kontakt Mette Brudvig",
      sub: "Har du spørgsmål om foredrag, retreats eller sessioner? Skriv en besked her.",
      addressTitle: "Placering & Virksomhed",
      addressText: "Mette Brudvig | Spanien & Danmark",
      emailLabel: "Direkte E-mail",
      emailValue: "mette@mettebrudvig.dk"
    },
    newsletter: {
      popupTitle: "Er du klar til at komme hjem til dig selv?",
      popupSubtitle: "Er du klar til at komme hjem til dig selv?",
      popupDesc: "Tilmeld dig nyhedsbrevet og få værktøjer, inspiration, viden og gratis meditationer direkte i din indbakke.",
      placeholder: "Indtast din e-mailadresse",
      subscribe: "Tilmeld mig nyhedsbrevet",
      subscribed: "Tak for din tilmelding!",
      close: "Luk"
    },
    privacy: {
      title: "Privatlivspolitik",
      sub: "Information om behandling af personoplysninger hos Mette Brudvig."
    }
  },
  en: {
    nav: {
      forloeb: "Education",
      workshops: "Courses",
      foredrag: "Keynotes",
      privat: "For Individuals",
      virksomheder: "Businesses",
      frisaetDig: "Unleash Yourself",
      kvindePower: "WOMAN - Know Your Power!",
      sessioner: "Sessions",
      retreats: "Retreats",
      sjaelensIntelligens: "Heart Intelligence",
      montserrat: "Montserrat",
      taenketank: "Think Tank",
      omMette: "About Mette",
      blog: "Blog",
      podcasts: "Podcast",
      gratis: "Free & Events",
      kontakt: "Contact",
      bookSession: "Book Session",
      bookMeeting: "Book a Meeting",
      quickLinks: "Quick Links",
      legal: "Legal",
      privacyPolicy: "Privacy Policy"
    },
    common: {
      readMore: "Read more",
      seeMore: "See more",
      backToHome: "Back to home",
      backToBlog: "Back to all posts",
      back: "Back",
      submit: "Send Message",
      submitting: "Sending...",
      successTitle: "Thank you for reaching out!",
      successMessage: "I will get back to you as soon as possible.",
      errorTitle: "An error occurred",
      errorMessage: "Please try again later or contact me directly via email.",
      contactHeader: "Let's start a conversation",
      contactSub: "Fill out the form below or write to me directly.",
      name: "Full Name",
      email: "Email Address",
      phone: "Phone Number",
      subject: "Subject / What is this regarding?",
      message: "Your Message",
      category: "Category",
      date: "Date",
      duration: "Duration",
      listenPodcast: "Listen to podcast on Spotify",
      readArticle: "Read full article",
      listenEpisode: "Listen to podcast episode",
      share: "Share this article",
      price: "Price",
      practical: "Practical Information",
      location: "Location",
      included: "What is included?",
      bookNow: "Register / Book here"
    },
    home: {
      badge: "The Age of the Heart & New Era Leadership",
      heroTitle: "New era personal leadership",
      heroSub: "Create a life of courage, trust, and soul connection",
      ctaPrimary: "Explore Unleash Yourself Program",
      ctaSecondary: "About Mette",
      introHeading: "Are you ready to step into your full potential?",
      introWelcome: "A warm welcome to my website.",
      introP1: "I help you wake up to yourself, connect with your intuition and soul core, and live an authentic life you love.",
      introP2: "The world needs people who feel themselves and can lead themselves and others from their pure essence, rather than from a series of triggers from old fear-based patterns and trauma.",
      introP3: "Do you also want to help create a better world? Start with yourself, and step into a new time and a new version of you, where soul connection and joy for life are the path to inner and outer peace.",
      introP4: "Here on this page, you can read about personal spiritual development, new era leadership, and the new era we are evolutionarily entering.",
      introCta: "Explore workshops & keynotes",
      videoTitle: "Welcome to my website",
      whoBadge: "Background & Vision",
      whoHeading: "Who am I?",
      whoP1: "I have lived on the old playing field myself, where the hamster wheel, career race, and fear of being different almost consumed me.",
      whoP2: "Until I woke up to my true essence and saw how different and wonderful life is when you dare to follow your life path and innate talents and gifts. And how much support life gives us when we find trust and courage to flow with it.",
      whoP3: "I have a background as Commercial Director, futurist, coach, journalist, educator, business developer, professional board member, clairvoyant advisor, and spiritual teacher.",
      whoP4: "However, that is not what matters most. What matters is that I understand how leadership, career, spiritual awakening, and living from your soul core create peace within the individual and thus peace in the world.",
      whoP5: "And that is my passion and life purpose: contributing to peace, sustainability, and true prosperity in the world, one human being at a time.",
      whoCta: "Contact me for an informal conversation",
      testimonialsHeading: "Are you ready to open up to the power and intelligence of the soul within you?",
      testimonialsSub: "Testimonials from others who chose to take the step inward with me:",
      testimonialsCta: "Read more about Mette here",
      podcastHeading: "Listen in the universe",
      podcastBadge: "Listen in",
      podcastFeatured: "Featured",
      podcastCta: "Explore all episodes & articles",
      bottomCtaHeading: "Do you want to start your journey today?",
      bottomCtaSub: "Whether through a keynote, an intimate retreat, or a 1:1 session, you are so welcome.",
      bottomCtaBtn: "Book a meeting / Contact"
    },
    foredragPage: {
      badge: "Inspiring Talks & Courses",
      title: "Keynotes & Workshops",
      sub: "Inspiring, eye-opening, and deeply transformative talks for organizations and individuals.",
      privateTabTitle: "For Individuals",
      privateTabDesc: "Strengthen your inner compass and unleash your own power.",
      businessTabTitle: "For Businesses",
      businessTabDesc: "Foster well-being, consciousness, and sustainable New Era Leadership.",
      bookingTitle: "Book a keynote or workshop",
      bookingSub: "Fill out the form to inquire about dates, pricing, and tailored programs."
    },
    frisaetDigPage: {
      badge: "Unleash Yourself",
      title: "Unleash Yourself",
      sub: "Do you wish to feel who you deep down are, and what a dream life is for you? To release yourself from old patterns and beliefs so you lovingly and worthily always have your own back and can calmly say no without regret.",
      section1Title: "About Unleash Yourself",
      section1Text: "Many of us were raised in a society where success is measured by outer achievements, strict control, and continuous performance. But when fear and overdeveloped control steer the wheel, we lose touch with our intuition and joy for life.",
      section1SubText: "Unleash Yourself is an invitation to lay down the exhausting armor and rediscover the deep calm and security living in your soul core.",
      pathwaysTitle: "3 Pathways to Release",
      foredragTitle: "1. Keynote",
      foredragDesc: "A powerful, engaging, and eye-opening keynote illuminating collective performance patterns and showing the way out.",
      workshopTitle: "2. Workshop",
      workshopDesc: "An immersive workshop featuring reflection, energy practices, and practical tools to release control and fear.",
      forloebTitle: "Mentoring Program",
      forloebDesc: "A deep 1:1 or small-group program where we systematically transform your limiting patterns into personal freedom."
    },
    kvindePowerPage: {
      badge: "Transformation",
      title: "WOMAN - Know Your Power!",
      sub: "The world does not need hard women with sharp elbows. It needs women who know their own power and dare to stand in it – with sensitivity, intuition, heart, and courage.",
      mainHeading: "Challenging the traditional view of a power woman",
      p1: "The world does not need women acting like men. The world needs women who know their strength and qualities and are able to stand in their full power with all the life-giving, peace-creating softness, finely tuned intuition, and maternal overview inherent in mature feminine energy.",
      p2: "My programs, workshops, and keynotes 'Woman – Know Your Power' focus on stepping out of performance traps and leading with the heart.",
      pathwaysTitle: "Join as a workshop, keynote, or program"
    },
    sessionerPage: {
      badge: "Personal Immersion",
      title: "1:1 Sessions",
      sub: "Gain clarity, direction, and deep connection to your intuition through clairvoyant advisory, executive mentoring, and spiritual programs.",
      tab1: "Clairvoyant Advisory & Personal Mentoring",
      tab2: "Confidential Intuitive Executive Mentoring",
      tab3: "Spiritual Mentoring Program",
      clairvoyanceTitle: "Clairvoyant Advisory & Personal Mentoring",
      clairvoyanceSub: "Do you need clarity and insight? Perhaps you stand at a crossroads, find it hard to feel yourself clearly, or need to understand what is calling you.",
      ledersparringTitle: "Confidential Intuitive Executive Mentoring",
      ledersparringSub: "A safe and conscious space for you as a leader, director, or entrepreneur seeking to lead with integrity, vision, and heart.",
      mentorTitle: "Spiritual Mentoring Program",
      mentorSub: "A dedicated and intensive multi-month journey for those seeking profound transformation and continuous support on their path."
    },
    retreatsPage: {
      badge: "Spiritual Immersion",
      title: "Retreats",
      sub: "Create space for reflection, recovery, and spiritual renewal in serene surroundings.",
      sjaelTitle: "Heart Intelligence Retreat",
      sjaelDesc: "Rediscover inner stillness and align with the universal field of consciousness.",
      montserratTitle: "Sacred Retreat to Montserrat",
      montserratDesc: "A 5-day pilgrimage to the monastery in the Spanish mountain landscape of Montserrat."
    },
    montserratPage: {
      badge: "Exclusive Pilgrimage",
      title: "Sacred Retreat to Montserrat",
      sub: "5 days of immersion, spiritual renewal, and inner peace in Catalonia's spectacular mountains.",
      programTitle: "Program & Experiences",
      priceTitle: "Pricing & Terms",
      bookingTitle: "Apply for a place on the Montserrat Retreat"
    },
    taenketankPage: {
      badge: "New Earth Leaders Academy",
      title: "NELA Think Tank & Education",
      sub: "Rethinking leadership. We establish new frameworks, new rules, and elevated states of consciousness.",
      philosophyTitle: "Philosophy: Old Frameworks – Old Rules",
      philosophyText: "Traditional hierarchical and performance-focused organizations burn out leaders and employees alike. NELA is the community for tomorrow's pioneering leaders."
    },
    omMettePage: {
      badge: "Welcome",
      title: "Welcome to Mette Brudvig",
      sub: "I help you return home to yourself, your heart, and your personal leadership.",
      intro: "I personally found it difficult to know where to turn when my soul and heart knocked on the door and asked for space. Therefore, I am glad to be that place for you. Either through inspiration here on the site, or because you wish to take your personal development journey with me."
    },
    udtalelserPage: {
      badge: "Client Testimonials",
      title: "Testimonials",
      intro: "Here you can see a selection of testimonials from clients who have been in sessions or programs with me."
    },
    blogPage: {
      badge: "Inspiration & Depth",
      title: "Blog",
      sub: "Inspiration, deep insights, and personal articles about the new era, heart intelligence, and spiritual transformation.",
      featuredBadge: "Featured Article",
      moreArticles: "More Articles",
      readFull: "Read full article",
      readMore: "Read more"
    },
    podcastsPage: {
      badge: "Listen in the universe",
      title: "Podcast",
      sub: "Conversations and deep reflections on the new era, heart intelligence, quantum physics, and personal leadership.",
      listenBelow: "Listen directly below",
      featuredBadge: "Featured Podcast",
      listenSpotify: "Listen on Spotify",
      listenBuzzsprout: "Buzzsprout (Web & episodes)",
      episodesTitle: "Episodes from Buzzsprout",
      episodesSub: "Explore all episodes from the podcast 'Connected in the New Era'. Listen to conversations about spirituality, quantum physics, astrology, and heart intelligence.",
      searchPlaceholder: "Search episodes (title, guest, topic...)",
      allEpisodes: "All episodes",
      listenOnBuzzsprout: "Listen on Buzzsprout",
      streamDirectly: "Stream recent episodes directly",
      duration: "Duration",
      playEpisode: "Play on page",
      pauseEpisode: "Pause",
      nowPlaying: "Now playing",
      rewind15: "Rewind 15 sec",
      forward15: "Forward 15 sec",
      closePlayer: "Close player",
      noEpisodesFound: "No episodes matched your search."
    },
    kontaktPage: {
      badge: "Start the Conversation",
      title: "Contact Mette Brudvig",
      sub: "Have questions regarding keynotes, retreats, or sessions? Send a message here.",
      addressTitle: "Location & Company",
      addressText: "Mette Brudvig | Spain & Denmark",
      emailLabel: "Direct Email",
      emailValue: "mette@mettebrudvig.dk"
    },
    newsletter: {
      popupTitle: "Are you ready to come home to yourself?",
      popupSubtitle: "Are you ready to come home to yourself?",
      popupDesc: "Subscribe to the newsletter and receive tools, inspiration, insights, and free meditations directly in your inbox.",
      placeholder: "Enter your email address",
      subscribe: "Subscribe to newsletter",
      subscribed: "Thank you for subscribing!",
      close: "Close"
    },
    privacy: {
      title: "Privacy Policy",
      sub: "Information regarding personal data processing at Mette Brudvig."
    }
  }
};

export function getTranslation(lang, keyPath) {
  const keys = keyPath.split('.');
  let current = translations[lang] || translations.da;
  for (const k of keys) {
    if (current && current[k] !== undefined) {
      current = current[k];
    } else {
      // Fallback to Danish if missing
      let fallback = translations.da;
      for (const fk of keys) {
        if (fallback && fallback[fk] !== undefined) fallback = fallback[fk];
        else return keyPath;
      }
      return fallback;
    }
  }
  return current;
}
